'use client'
/* eslint-disable react/jsx-no-literals */
import React from 'react'
import styled from 'styled-components'
import { Text } from '../Text'
import Link from 'next/link'

const Container = styled.div`
  width: 100%;
  height: 100%;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 6rem;
  font-family: inherit;
  color: #4a4a4a;
`

const ErrorImage = styled.img`
  width: 7rem;
  height: auto;
`

const ErrorMessage = styled.h4`
  margin-bottom: 0.5rem;
`

const LinkButton = styled(Link)`
  display: inline-block;
  background-color: #4ab819;
  padding: 0.6rem 1rem;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.875rem;
  border: 1px solid transparent;
  border-radius: 2px;
  letter-spacing: -0.3px;
  cursor: pointer;
  text-align: center;
`

const UnavailableStore = () => {
  return (
    <Container>
      <ContentWrapper>
        <ErrorImage
          src="https://i1.zopping.com/zopping-uploads/160/20220915/alert-20220915-055527.jpg"
          alt="Error"
        />
        <ErrorMessage>
          <Text tid="storeUnavailable" />
        </ErrorMessage>
        <p>
          <LinkButton href="https://zopping.com">
            <Text tid="SetupYourStoreOnZopping" />
          </LinkButton>
        </p>
      </ContentWrapper>
    </Container>
  )
}

export default UnavailableStore
